import {Component} from "react";
import React from "react";
import PropTypes from 'prop-types';
const I18n = require('react-redux-i18n').I18n;

export default class PatientListItem extends Component {

    constructor(props) {
        super(props);
    }

    render () {
        return (
            <div className={this.props.selected ? "selected" : ""} onClick={this.props.onClick}>
                <span>{this.props.patient.firstName ? this.props.patient.firstName : I18n.t('Not Available')}</span>
                <span>{this.props.patient.lastName ? this.props.patient.lastName : I18n.t('Not Available')}</span>
            </div>
        );
    }
}

PatientListItem.PropTypes = {
    patient: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
    })
};